import { render, staticRenderFns } from "./DatasetDetailView.vue?vue&type=template&id=ec7b1646&scoped=true"
import script from "./DatasetDetailView.vue?vue&type=script&lang=js"
export * from "./DatasetDetailView.vue?vue&type=script&lang=js"
import style0 from "./DatasetDetailView.vue?vue&type=style&index=0&id=ec7b1646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7b1646",
  null
  
)

export default component.exports